module.exports = "/_next/static/images/ExtensibleDocumentation@2x-36bab03642083da263bf8c04c8134c7d.png";